// QR code display with copy-to-clipboard link
import { useState } from 'react'
import { Copy, Check } from 'lucide-react'

import { Button } from '@/ui/button'

export function QRDisplay({ token }: { token: string }) {
  const [copied, setCopied] = useState(false)
  const url = `${window.location.origin}/join/${token}`

  function copy() {
    navigator.clipboard.writeText(url).catch(() => {})
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="flex flex-col items-center gap-3">
      {/* QR image via free public API */}
      <div className="border-2 border-slate-150 rounded-xl p-2 bg-white">
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(url)}&size=160x160&margin=4`}
          alt="QR Code"
          width={160}
          height={160}
          className="rounded"
          onError={(e) => {
            // Fallback if QR API unavailable
            ;(e.target as HTMLImageElement).style.display = 'none'
          }}
        />
      </div>
      <div className="w-full bg-gray-50 rounded-lg px-3 py-2 text-xs font-mono text-slate-500 text-center break-all">
        {url}
      </div>
      <Button variant="outline" size="sm" onClick={copy} className="w-full">
        {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
        {copied ? '¡Copiado!' : 'Copiar enlace'}
      </Button>
    </div>
  )
}
